export default "__VITE_ASSET__BMg6YTeZ__"